import * as React from 'react';
import { classes, style } from 'typestyle';
import { tinyCssProps } from '../../../styles/text';
import { Blue, White } from '../../../styles/colors';
import ButtonAtom from '../../atoms/button/ButtonAtom';
import { ButtonStateTypes, ButtonStyleTypes, stateStylesSet, stylesSet, } from '../../../styles/button';
import { getStateDependentValues } from './helpers';
const duplexButtonStyles = {};
/**
 * This type is here because of backward compatibility.
 */
export var DuplexButtonStyleTypes;
(function (DuplexButtonStyleTypes) {
    DuplexButtonStyleTypes["ActiveA"] = "activeA";
    DuplexButtonStyleTypes["ActiveB"] = "activeB";
    DuplexButtonStyleTypes["ActiveC"] = "activeC";
    DuplexButtonStyleTypes["SuccessA"] = "successA";
    DuplexButtonStyleTypes["NeutralA"] = "neutralA";
    DuplexButtonStyleTypes["NeutralB"] = "neutralB";
    DuplexButtonStyleTypes["NeutralC"] = "neutralC";
    DuplexButtonStyleTypes["WarnA"] = "warnA";
    DuplexButtonStyleTypes["WarnB"] = "warnB";
    /**
     * @deprecated Use single "disabled" prop instead.
     */
    DuplexButtonStyleTypes["Disabled"] = "disabled";
    DuplexButtonStyleTypes["Default"] = "default";
})(DuplexButtonStyleTypes || (DuplexButtonStyleTypes = {}));
const duplexStylesSet = Object.assign(Object.assign(Object.assign({}, stylesSet), stateStylesSet), { neutralC: Object.assign(Object.assign({}, stylesSet.neutralC), { backdropFilter: 'blur(25px)' }) });
export const duplexSmallStylesSet = Object.assign(Object.assign({}, stateStylesSet), { activeA: {
        color: White,
    }, activeB: {
        color: Blue,
    }, activeC: {
        color: Blue,
    } });
const DuplexButton = (props) => {
    const { onClick, className, raised = false, small = false, type, disabled = false, pending = false, done = false, } = props;
    const { icon, title, styleType } = getStateDependentValues(props);
    return (React.createElement(ButtonAtom, { title: title, icon: icon, type: type, className: classes('ta-duplex-btn', className, styleType && duplexButtonStyles[styleType], duplexButtonStyle, raised && raisedStyle, small && `${smallStyle} ${duplexButtonStyles[styleType + 'Small']}`), disabled: disabled || pending || done, onClick: onClick }));
};
export default DuplexButton;
const raisedStyle = style({
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.35)',
});
const duplexButtonStyle = style({
    flexDirection: 'column',
    padding: '6px',
    height: 'auto',
    minWidth: 60,
    borderRadius: 12,
    display: 'flex',
    $nest: {
        '&:hover': {
            textDecoration: 'none',
        },
        '&:focus': {
            textDecoration: 'none',
        },
        '& > img': {
            marginRight: 6,
        },
        '& > .ta-btn-title': Object.assign({ display: 'flex', width: '100%', justifyContent: 'center' }, tinyCssProps),
        '& > .ta-btn-icon + span': {
            marginLeft: 0,
        },
    },
});
const smallStyle = style({
    height: 36,
    minWidth: 24,
    padding: 0,
    borderRadius: 0,
});
const duplexButtonColorStyle = (styleType) => {
    const { background, color, backdropFilter, cursor } = duplexStylesSet[styleType];
    return style({
        background,
        backdropFilter: backdropFilter || '',
        cursor: cursor || '',
        $nest: {
            '& > .ta-btn-title': {
                color,
            },
        },
    });
};
const smallColorStyle = (styleType) => {
    const properties = duplexSmallStylesSet[styleType];
    if (!properties) {
        return '';
    }
    const { color, cursor } = properties;
    return style({
        background: 'transparent',
        cursor: cursor || '',
        $nest: {
            '& > .ta-btn-title': {
                color,
            },
        },
    });
};
// Typestyles priorities:
// 1. use style functions + order of running (last run more important).
// 2. if use no style function then style definition near end of file
const styleMap = Object.assign(Object.assign({}, ButtonStyleTypes), ButtonStateTypes);
const styleKeys = Object.keys(styleMap);
styleKeys.forEach(t => (duplexButtonStyles[styleMap[t]] = duplexButtonColorStyle(styleMap[t])));
styleKeys.forEach(t => (duplexButtonStyles[styleMap[t] + 'Small'] = smallColorStyle(styleMap[t])));
//# sourceMappingURL=DuplexButton.js.map